<template>
  <div class="">
    <b-carousel
      ref="myCarousel"
      id="carousel-1"
      v-model="slide"
      :interval="5000"
      background="#ababab"
      style="text-shadow: 1px 1px 2px #333"
    >
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="480"
            src="@/assets/protelBanner.jpg"
            alt="image slot"
          />
        </template>
        <h1 class="col-xl-5 col-md-5 col-sm-12 Cheader">{{ $t("Scroll1h") }}</h1>
        <p class="col-xl-5 col-md-5 col-sm-12 Cpar">
          {{ $t("Scroll1p") }}
        </p>
        <p v-on:click="scroll(1)" class="col-xl-5 col-md-5 col-sm-12 Cl"><span class="navItem">{{ $t("Scroll1l") }}</span></p>
      </b-carousel-slide>

      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="480"
            src="@/assets/protelBanner2.jpg"
            alt="image slot"
          />
        </template>
        <h1 class="col-xl-5 col-md-5 col-sm-12 Cheader">{{ $t("Scroll2h") }}</h1>
        <p class="col-xl-5 col-md-5 col-sm-12 Cpar">
          {{ $t("Scroll2p") }}
        </p>
      </b-carousel-slide>
      <b-carousel-slide>
        <template #img>
          <img
            class="d-block img-fluid w-100"
            width="1024"
            height="480"
            src="@/assets/protelBanner3.jpg"
            alt="image slot"
          />
        </template>
        <h1 class="col-xl-5 col-md-5 col-sm-12 Cheader">{{ $t("Scroll3h") }}</h1>
        <p class="col-xl-5 col-md-5 col-sm-12 Cpar">
          {{ $t("Scroll3p") }}
        </p>
      </b-carousel-slide>
    </b-carousel>
    <div style="text-align: right">
      <button class="cButton" @click="prev()">&lt;</button>
      <button class="cButton" @click="next()">&gt;</button>
    </div>
  </div>
</template>

<script>
export default {
  name: "Jtron",
  data() {
    return {
      slide: 0,
      sliding: "",
    };
  },
  async mounted() {},

  methods: {
    prev() {
      this.$refs.myCarousel.prev();
    },
    next() {
      this.$refs.myCarousel.next();
    },
    scroll(id) {  
      document.getElementById(id).scrollIntoView({
        behavior: "smooth"
      });
    },
  },

  components: {},
  props: {},

  computed: {},
};
</script>

<style scoped>
.cButton {
  background-color: #2d3037;
  border: none;
  padding-left: 15px;
  padding-right: 15px;
  color: white;
}
.cButton:hover {
  background-color: red;
  border: none;
  padding-left: 15px;
  padding-right: 15px;
  color: white;
}

.navItem {
  display: inline-block;
  padding-bottom:2px;
  background-image: linear-gradient(white, white);
  background-position: 0 100%; /*OR bottom left*/
  background-size: 0% 2px;
  cursor: pointer;
  background-repeat: no-repeat;
  transition:
  background-size 0.3s,
  background-position 0s 0.3s; /*change after the size immediately*/
}
.navItem:hover {
 background-position: 100% 100%; /*OR bottom right*/
  background-size: 100% 2px;
}
</style>
<style>
.carousel-caption {
  top: 35% !important;
  text-align: left !important;
}

@media only screen and (max-width: 770px) {
  .carousel-caption {
  top: 0 !important;
  text-align: left !important;
}
.Cheader{
  font-size: 12px;
}
.Cpar{
  font-size: 10px;
}
.Cl{
  font-size: 9px;
}
}
</style>